import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { mapMessageToEventItem } from '@/common/analytics/gtm/mappers';
import { EventMessage } from '@/common/analytics/gtm/types';

const trackUAWishlistAction = (eventMessage: EventMessage, action: string) => {
  if (eventMessage.metadata.messageSendingDisabled) return;
  const {
    message: { internalId, externalId, name },
  } = eventMessage;
  createTrackingEvent({
    event: 'wishlistAction',
    category: 'Wishlist',
    action: action,
    productID: internalId,
    productSKU: externalId,
    productName: name || '',
  });
};

export const trackUAAddToWishlist = (eventMessage: EventMessage) => {
  return trackUAWishlistAction(eventMessage, 'Add to Wishlist');
};

export const trackUARemoveFromWishlist = (eventMessage: EventMessage) => {
  return trackUAWishlistAction(eventMessage, 'Remove from Wishlist');
};

export const trackGA4AddToWishlist = (eventMessage: EventMessage) => {
  if (eventMessage.metadata.messageSendingDisabled) return;
  createTrackingEvent({
    event: 'sst_add_to_wishlist',
    ecommerce: {
      method: `${eventMessage.metadata.gaPageName}|${eventMessage.metadata.listingType}`,
      items: [mapMessageToEventItem(eventMessage)],
    },
  });
};

export const trackGA4RemoveFromWishlist = (eventMessage: EventMessage) => {
  if (eventMessage.metadata.messageSendingDisabled) return;
  createTrackingEvent({
    event: 'sst_remove_from_wishlist',
    ecommerce: {
      method: `${eventMessage.metadata.gaPageName}|${eventMessage.metadata.listingType}`,
      items: [mapMessageToEventItem(eventMessage)],
    },
  });
};
